import React from 'react';
import { ACCENT_COLOR } from './colors';

const Cancel = ({
  width = 20,
  className = '',
  fill = ACCENT_COLOR,
}) => (
  <svg
    className={`svg-icon ${className || ''}`}
    width={width}
    height={width}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <circle cx="10" cy="10" r="10" fill={fill} />
    <path d="M14 6L6 14" stroke="#F7F7F7" strokeWidth="2" />
    <path d="M14 14L6 6" stroke="#F7F7F7" strokeWidth="2" />
  </svg>
);

export default Cancel;
